import { GridCellParams } from '@mui/x-data-grid-pro';
import { v4 } from 'uuid';
import { GridCustomColDef } from '../../../../types';
import { DetailCTARenderer } from '../../../../Compounds/UpstackDataGrid/CellRenderers/DetailCTARenderer';
import { ComponentName, getMetaData } from '../../../../Compounds/DetailsDrawer/detailsDrawersHelpers';
import { Icon } from '../../../../Atoms/Icon';

export const sfdcTableCols: GridCustomColDef[] = [
  {
    type: 'actions',
    field: 'details',
    cellClassName: 'details-cell',
    headerName: 'Details',
    sortable: false,
    hideable: false,
    width: 65,
    filterable: false,
    renderCell: (params: GridCellParams) => (
      <DetailCTARenderer
        data={params}
        value={''}
        valueFormatted={''}
        state={{
          id: v4(),
          data: params.row,
          ...getMetaData({ name: ComponentName.PRODUCT_MAP, id: params.row.id || '' })
        }}
      />
    ),
    pinned: 'left',
    disableReorder: true
  },
  {
    headerName: 'RPM Supplier',
    field: 'rpmProductSupplierName',
    flex: 2,
    sortable: true,
    renderCell: (params: GridCellParams) => (
      <a
        className="text-indigo"
        title="Open in RPM"
        href={`${process.env.REACT_APP_RPM_URL}/rpm/Page/Supplier.aspx?Item=${params.row.rpmProductSupplierId}`}
        target="_blank"
        rel="noopener noreferrer">
        <div className="flex items-center text-small">
          {params.row.rpmProductSupplierName}
          <Icon type="external" />
        </div>
      </a>
    )
  },
  {
    headerName: 'RPM Product',
    field: 'rpmProductName',
    flex: 2,
    sortable: true,
    renderCell: (params: GridCellParams) => (
      <a
        className="text-indigo"
        title="Open in RPM"
        href={`${process.env.REACT_APP_RPM_URL}/rpm/Page/Product.aspx?Item=${params.row.rpmProductId}`}
        target="_blank"
        rel="noopener noreferrer">
        <div className="flex items-center text-small">
          {params.row.rpmProductName}
          <Icon type="external" />
        </div>
      </a>
    )
  },
  {
    field: 'note',
    headerName: 'Note',
    sortable: true,
    flex: 1,
    description: 'Drag to move column'
  },
  {
    field: 'rpmProductId',
    headerName: 'RPM ID',
    sortable: true,
    flex: 1,
    description: 'Drag to move column'
  }
];
